import React from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import Loader from "components/Loader";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// local
import FamilyContainer from "./FamilyContainer";
import Filters from "./Filters";

// redux
import { useSelector, useDispatch } from "react-redux";
import * as actions from "redux/actions/family";
import * as actionTypes from "redux/constants";

const Family = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const family = useSelector((state) => state.family);
  const auth = useSelector((state) => state.auth);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [family.pagination.page]);

  React.useEffect(() => {
    dispatch(actions.getFamilies(family.pagination.page, family.pagination.pageSize));

    return () => {
      dispatch(actions.resetFamilyPagination());
    }
  }, [dispatch]);

  const handlePagination = (page) => {
    dispatch(actions.getFamilies(page, family.pagination.pageSize));
  }

  const handleDelete = (id) => {
    const payload = { id };
    dispatch(actions.deleteFamily(payload));
  };

  const handleEdit = (data) => {
    navigate(`/upload/family/add-family`, { state: { editData: data } });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container>
        {family.loading ? (
          <Loader />
        ) : (
          <>
            {actionTypes.ADVANCED_SECTION.includes(auth.user?.role) && (
              <Grid item xs={12} md={12} xl={12}>
                <MDBox py={3} pl={1}>
                  <Filters />
                </MDBox>
              </Grid>
            )}
            <Grid item xs={12} md={12} xl={12}>
              <MDBox py={3} pr={1}>
                <FamilyContainer families={family.families} pagination={family.pagination} handlePagination={handlePagination} handleDelete={handleDelete} handleEdit={handleEdit} />
              </MDBox>
            </Grid>
          </>
        )}
      </Grid>
    </DashboardLayout>
  );
};

export default Family;
